export const SIZE_OCCURRENCE = 'SizeOccurrence';
//# sourceMappingURL=size-occurrence.js.map